import { useDocumentsViewModel } from "@miplatform/view-models";
import { useContacts, useDepartments, useSeries } from "@mibuildweb/hooks";

export const useBidDetailsFormViewModel = () => {
  const { contacts, getContacts } = useContacts();
  const { series, getSeries } = useSeries();
  const { departments, getDepartments } = useDepartments();
  const {
    loading: isDocLoading,
    uploadDocument,
    removeDocument,
  } = useDocumentsViewModel();

  const getAllData = async () => {
    await Promise.all([
      getContacts({ filters: { status: "Active" } }),
      getDepartments({ filters: { name: "Estimating" } }),
    ]);
  };

  const fetchSeries = async (builderId: string, seriesGroupId?: string) => {
    const seriesGroupIdFilter = seriesGroupId
      ? { type: "guid", value: seriesGroupId }
      : { type: "guid", value: null };

    await getSeries({
      filters: {
        accountId: { type: "guid", value: builderId },
        seriesGroupId: seriesGroupIdFilter,
      },
    });
  };

  return {
    loading: isDocLoading,
    contacts,
    series,
    departments,
    getAllData,
    fetchSeries,
    uploadDocument,
    removeDocument,
  };
};
